import { InitComponentStateType, createComponentState } from '@/state';
import { beginEvalution, loadEvaulation, reloadEvaluation } from '../../api/services';
import { createNotification, handleError } from '@/utils';

import HasPermission from '@/components/HasPermission';
import Toast from '@/models/Toast';
import { TrainingChecklistTableTypes } from './types';

export type TrainingChecklistTableState = {
  rows: TrainingChecklistTableTypes.ChecklistItem[];
  categoryWithQuestionMap: Record<string, TrainingChecklistTableTypes.CategoryWithQuestions>;
  evaluationId: string | null;
  totalAttempts: number;
  load: (userId: string) => Promise<void>;
  evaluate: (subjectUserId: string) => Promise<void>;
  reload: () => Promise<void>;
};

export const initTrainingChecklistTableState: InitComponentStateType<TrainingChecklistTableState> = (set, get) => ({
  rows: [],
  categoryWithQuestionMap: {},
  evaluationId: null,
  submittedAt: null,
  submittedBy: null,
  totalAttempts: 0,

  load: async (userId): Promise<void> => {
    try {
      const response = await loadEvaulation(userId);
      set((current) => ({
        ...current,
        rows: response.rows,
        categoryWithQuestionMap: response.categoryWithQuestionMap,
        evaluationId: response.evaluationId,
        submittedAt: response.submittedAt,
        submittedBy: response.submittedBy,
        totalAttempts: response.totalAttempts,
      }));
    } catch (err) {
      handleError(err, { notification: { title: 'Get Training Checklist' } });
    }
  },

  evaluate: async (subjectUserId): Promise<void> => {
    try {
      let { evaluationId } = get().state;
      if (!HasPermission.check('allowEditTrainingEvaluation') && !evaluationId) {
        createNotification('You do not have permission to start a training evaluation.', Toast.Type.WARNING, 'Training Evaluation');
        return;
      }
      // being evaluated will create a new attempt or use existing attempt
      const response = await beginEvalution(subjectUserId, evaluationId);
      set((current) => ({
        ...current,
        rows: response.rows,
        categoryWithQuestionMap: response.categoryWithQuestionMap,
        evaluationId: response.evaluationId,
        submittedAt: response.submittedAt,
        submittedBy: response.submittedBy,
      }));
    } catch (err) {
      handleError(err, { notification: { title: 'Start Evaluation' } });
    }
  },

  reload: async (): Promise<void> => {
    try {
      const { evaluationId } = get().state;
      const response = await reloadEvaluation(evaluationId);
      set((current) => ({
        ...current,
        rows: response.rows,
        categoryWithQuestionMap: response.categoryWithQuestionMap,
        submittedAt: response.submittedAt,
        submittedBy: response.submittedBy,
      }));
    } catch (err) {
      handleError(err, { notification: { title: 'Reload Trainig Checklist' } });
    }
  },
});

const useTrainingChecklistTableState = createComponentState(initTrainingChecklistTableState);

export default useTrainingChecklistTableState;
